import { createRoute } from "@tanstack/react-router";
import { TrainingPage } from ".";
import { rootRoute } from "@/routing/routes";
import { TrainingCertificatePage } from "./TrainingCertificatePage";

const root = createRoute({
  path: "/training",
  getParentRoute: () => rootRoute,
});

const index = createRoute({
  path: "/",
  getParentRoute: () => root,
  component: TrainingPage,
});

const certificate = createRoute({
  path: "/certificate",
  getParentRoute: () => root,
  component: TrainingCertificatePage,
});

export const trainingRoutes = root.addChildren([index, certificate]);
